import { RedirectWithQuery } from '@xylabs/sdk-react'
import React from 'react'
import { useParams } from 'react-router-dom'

const RedirectToMedium: React.FC = () => {
  const { id } = useParams()
  return <RedirectWithQuery to={`/auction/${id}/card/md`} />
}

export default RedirectToMedium
